import React from 'react';
import { Phone, ArrowLeft, Shield, RefreshCw, Check, AlertCircle } from 'lucide-react';
import '../../styles/Auth.css';

const OTPVerificationModal = ({
  mobile,
  otp,
  handleFullOtpChange,
  otpMethod,
  timer,
  canResend,
  resendOTP,
  verifyOTP,
  setAuthStep,
  userProfile,
  setUserProfile,
  error
}) => {
  return (
    <div className="signup-container">
      <div className="signup-card">
        <button
          onClick={() => setAuthStep('phone')}
          className="flex items-center gap-2 text-gray-600 mb-6 hover:text-blue-600 transition-colors font-medium group"
        >
          <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
          <span>Back</span>
        </button>

        <div className="signup-header">
          <div className="logo">
            <Shield size={30} className="text-white" />
          </div>
          <h2>Verify OTP</h2>
          <p className="subtitle">
            Code sent via {otpMethod === 'both' ? 'SMS & WhatsApp' : otpMethod === 'whatsapp' ? 'WhatsApp' : 'SMS'} to +91 {mobile}
          </p>
        </div>

        <div className="form-group">
          <label className="text-center block">
            Enter 6-digit verification code
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            autoFocus
            value={otp.join('')}
            onChange={(e) => handleFullOtpChange(e.target.value)}
            placeholder="______"
            className="w-full border-2 border-gray-200 rounded-xl px-4 py-3 text-center text-2xl font-bold tracking-[0.6em] outline-none focus:border-blue-500 transition-all mt-2"
          />

          {error && (
            <div className="error-message-general">
              <AlertCircle size={18} className="text-red-600 flex-shrink-0 mt-0.5" />
              <span>{error}</span>
            </div>
          )}

          <div className="otp-timer">
            {canResend ? (
              <button
                onClick={resendOTP}
                className="resend-btn inline-flex items-center gap-2"
              >
                <RefreshCw size={16} />
                <span>Resend OTP</span>
              </button>
            ) : (
              <p>
                Resend available in <span className="font-semibold">{timer}s</span>
              </p>
            )}
          </div>
        </div>

        <button
          onClick={verifyOTP}
          disabled={otp.join('').length !== 6}
          className="submit-btn"
        >
          <span className="inline-flex items-center gap-2">
            <Check size={20} />
            Verify & Continue
          </span>
        </button>
      {process.env.NODE_ENV === 'local' && (
        <div className="success-message mt-6">         
          <p>
            <span className="font-semibold">💡 Demo Mode:</span> Use code <span className="font-mono font-bold">123456</span>
          </p>      
        </div>
        )}
        <p className="footer mt-4">
          🔒 Your data is encrypted and secure
        </p>
      </div>
    </div>
  );
};

export default OTPVerificationModal;